import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { type JSX } from 'react';

interface AdminSettingsCardProps {
  icon: JSX.Element;
  title: string;
  subtitle: string;
  onEdit: () => void;
}

const AdminSettingsCard: React.FC<AdminSettingsCardProps> = ({ icon, title, subtitle, onEdit }) => {
  return (
    <Card variant='ghost' color='primary' sx={{ height: '100%' }}>
      <CardContent sx={{ display: 'flex', flexDirection: 'column', p: 2.5, height: '100%' }}>
        <Box sx={{ mb: 3 }}>{icon}</Box>
        <Box sx={{ flex: 1 }} display='flex' justifyContent='space-between' alignItems='flex-end'>
          <Box sx={{ minWidth: 0, flex: 1, mr: 2 }}>
            <Typography variant='p20Bold' color='secondary.main' display='block'>
              {title}
            </Typography>
            <Typography variant='p18' color='secondary.main' display='block' sx={{ mt: 0.7 }}>
              {subtitle}
            </Typography>
          </Box>
          <Button
            variant='outlined'
            color='secondary'
            onClick={onEdit}
            sx={{ minWidth: '120px', flexShrink: 0, typography: 'p18SemiBold' }}>
            Edit
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default AdminSettingsCard;
